import React ,{useState}from 'react'
import styled from 'styled-components'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';


function Header() {
  const [burgerStatus,setBurgerStatus]=useState(false);
  return (
    <Container>
     <a>
      <img src="/images/logo.svg" alt=""/>
     </a>
     <Menu>
      <a href="#">MODEL S</a>
      <a href="#">MODEL X</a>
      <a href="#">MODEL Y</a>
      <a href="#">MODEL 3</a>
      
     </Menu>
     <RightMenu>
      <a href="#">SHop</a>
      <a href="#">tesla account</a>
      <CustomMenu onClick={()=>setBurgerStatus(true)} />
     </RightMenu>
     <BurgerNav show={burgerStatus}>
      <CloseWrapper >
      <CustomClose onClick={()=>setBurgerStatus(false)}></CustomClose>
      </CloseWrapper>
      <li><a href="#">MODEL S</a></li>
      <li><a href="#">MODEL X</a></li>
      <li><a href="#">MODEL Y</a></li>
      <li><a href="#">MODEL 3</a></li>
      <li><a href="#">Used Inventory</a></li>
      <li><a href="#">Trade-in</a></li>
      <li><a href="#">Cybertruck</a></li>
      <li><a href="#">Roadaster</a></li>
     </BurgerNav>
    </Container>
  )
}

export default Header

const Container=styled.div`
min-height:60px;
position:fixed;
display:flex;
align-items:center;
padding: 0 20px;
top:0;
left:0;
right:0;
z-index:1;


`
const Menu=styled.div`
display:flex;
align-items:center;
justify-content:space-between;

flex:1;
a{
  font-weight:600;
  text-transform:uppercase;
  padding:0 10px;
  flex-wrap:nowrap;
  color:black;
  @media(max-width:768px){
    display:none;
  }
}
`
const RightMenu=styled.div`
display:flex;
align-items:center;

a{
  font-weight:600;
  text-transform:uppercase;
  padding:0 10px;
  flex-wrap:nowrap;
  color:black;
}
@media(max-width:768p{
 a{
  font-weight:400;
 } 
  }
`
const CustomMenu=styled(MenuIcon)`
 cursor:pointer;
`
const BurgerNav=styled.div`
   position:fixed;
   top:0;
   bottom:0;
   right:0;
   background:white;
   width:300px;
   z-index:16;
   list-style:none;
   padding:20px;
   display:flex;
   flex-direction:column;
   text-align:start;
   transform:${props=>props.show?'translateX(0%)':'translateX(100%)'};
   transition:transform 0.4s;
   li{
    padding :15px 0;
    border-bottom:1px solid rgba(0,0,0,.2);
    text-transform:uppercase;
    a{
      font-weight:600;
    }
   }
   `
const CustomClose=styled(CloseIcon)`
 cursor:pointer;
` 
const CloseWrapper=styled.div`
display:flex;
justify-content:flex-end;
`  